





















































































































































import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator'
import { mapGetters } from 'vuex'
import { saveUsersRequestForMoreInformationAboutLotAsync } from '~/api/consumer_map.api'
import { LotInfo, Realtor, Employer } from '~/models'
import { uiStore } from '~/store'
import Input from '~/components/shared/inputs/Input.vue'
import debounce from '~/utils/debounce'
import { getLookupOptions } from '~/api/lookups.api'
import { getRealtor } from '~/api/realtor.api'
import { InputType } from '~/enums/inputType'
import { Events } from '~/utils/eventLayers'
import { LotTypes } from '~/enums/lots'

@Component({
  components: {
    Input,
  },
  computed: {
    ...mapGetters('consumer-map', {
      queryParams: 'queryParams',
    }),
  },
})
export default class ContactForm extends Vue {
  queryParams: any

  @Prop({ default: () => {} }) lot: LotInfo
  @Prop({ default: false }) showRealtor: Boolean

  fName: string = ''
  lName: string = ''
  phone: string = ''
  email: string = ''
  zipcode: string = ''
  comments: string = ''
  isSubmitted: boolean = false
  loadLookupOptionsDebounced: Function
  isRealtor: boolean = false
  realtorId: number = 0
  realtor: Realtor = null

  realtorLookupSetting: any = {
    id: 'realtor',
    label: 'Realtor Information',
    type: InputType.realtorTextTypeahead,
    settings: { options: [], lookup: 'realtor', editable: false },
  }

  emailInvalid: boolean = false

  @Watch('realtorId')
  onRealtorChange(value: number): void {
    this.onRealtorIdChange(value)
  }

  mounted() {
    this.loadLookupOptionsDebounced = debounce(this.loadLookupOptions, 500)
  }

  get submissionEnabled() {
    const result = !!(this.fName && this.lName && this.phone && this.email)
    return result
  }

  async checkForm() {
    uiStore.updateLoding(true)
    try {
      if (this.isRealtor) {
        await saveUsersRequestForMoreInformationAboutLotAsync(this.lot.slug, {
          first_name: this.realtor.first_name,
          last_name: this.realtor.last_name,
          phone: this.realtor.phone,
          email: this.realtor.email,
          comments: this.comments,
          realtor_id: this.realtor.id,
          zipcode: this.zipcode,
          query_params: this.queryParams,
        })
      } else {
        await saveUsersRequestForMoreInformationAboutLotAsync(this.lot.slug, {
          first_name: this.fName,
          last_name: this.lName,
          phone: this.phone.replace(/\D/g, ''),
          email: this.email,
          comments: this.comments,
          zipcode: this.zipcode,
          query_params: this.queryParams,
        })
      }

      this.isSubmitted = true

      const category: string =
        this.lot.type === LotTypes.HOME_SITE ? 'homesite' : 'home'

      Events.submitRequestInfo(
        'mapFormSubmit',
        category,
        'submit | request information',
        'map',
        this.lot?.builder.name,
        this.lot
      )
    } catch (err) {
      console.error(err)
    } finally {
      uiStore.updateLoding(false)
    }
  }

  handleReset() {
    this.fName = ''
    this.lName = ''
    this.phone = ''
    this.email = ''
    this.comments = ''
    this.realtor = null
  }

  async loadLookupOptions(search: string, control: any): Promise<void> {
    try {
      let lookupOptions: Array<Employer | Realtor> = []
      const { lookup } = control.settings
      if (lookup) {
        lookupOptions = search ? await getLookupOptions(search, lookup) : []
      }

      control.settings = {
        ...control.settings,
        options: lookupOptions,
      }
    } catch (e) {
      console.log(e)
    }
  }

  async onRealtorIdChange(value: number) {
    if (value) {
      const realtor = await getRealtor(value)
      this.realtor = realtor
      this.fName = realtor?.first_name || ''
      this.lName = realtor?.last_name || ''
      this.phone = realtor?.phone || ''
      this.email = realtor?.email || ''

      this.realtorLookupSetting.settings = {
        ...this.realtorLookupSetting.settings,
        options: [realtor],
      }
    }
  }

  maskPhoneNumber(event: any) {
    const value = event.target.value
    // Remove non-digit characters from input
    const phoneNumber = value.replace(/\D/g, '')

    // Apply the mask
    let maskedNumber = ''
    if (phoneNumber.length > 2) {
      maskedNumber += phoneNumber.substring(0, 3)
    }
    if (phoneNumber.length > 3) {
      maskedNumber += '-' + phoneNumber.substring(3, 6)
    }
    if (phoneNumber.length > 6) {
      maskedNumber += '-' + phoneNumber.substring(6, 10)
    }

    // Update the input field value with the masked number
    this.phone = maskedNumber || phoneNumber
  }

  validateEmail(event: any): void {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    this.emailInvalid = !re.test(event.target.value)
  }
}
